var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgMatic = function SvgMatic(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#7B3FE4"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M13.055 7.898a.754.754 0 0 0-.752 0l-1.727 1.029-1.174.67-1.727 1.03a.754.754 0 0 1-.752 0L5.55 9.822a.773.773 0 0 1-.376-.649V7.585a.726.726 0 0 1 .376-.648l1.35-.783a.754.754 0 0 1 .753 0l1.35.783a.773.773 0 0 1 .377.648v1.029l1.173-.693V6.89a.726.726 0 0 0-.376-.648L7.675 4.767a.754.754 0 0 0-.752 0L4.376 6.243A.726.726 0 0 0 4 6.892v2.974a.726.726 0 0 0 .376.649l2.547 1.476a.754.754 0 0 0 .752 0l1.727-1.006 1.174-.694 1.727-1.006a.753.753 0 0 1 .752 0l1.35.783a.772.772 0 0 1 .377.648v1.588a.726.726 0 0 1-.376.649l-1.35.805a.754.754 0 0 1-.753 0l-1.351-.783a.772.772 0 0 1-.376-.649v-1.028l-1.174.693v1.029a.726.726 0 0 0 .377.648l2.546 1.476a.754.754 0 0 0 .752 0l2.546-1.476A.773.773 0 0 0 16 13.02v-2.975a.726.726 0 0 0-.377-.648l-2.568-1.499Z",
    fill: "white"
  })));
};
export default SvgMatic;